"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _lodash = _interopRequireDefault(require("lodash.size"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

/**
 * PATH - in the API can be in one of the following forms:
 * A storage service path. Example: cloud-content/56475bf9-dd79-401b-8978-9b88780bae41.xdc
 * A storage service id-based path. Example: id/urn:aaid:sc:US:2f86d5e2-0fd2-49b8-a05e-6a47cd056486
 * A full storage service path-based URL. Example: https://cc-api-storage-stage.adobe.io/cloud-content/56475bf9-dd79-401b-8978-9b88780bae41.xdc
 * A full storage service id-based URL. Example: https://cc-api-storage-stage.adobe.io/id/urn:aaid:sc:US:05286244-1eae-4e51-89a9-9ac99d6647f5
 */

/**
 * Share endpoint for api version three.
 */
var ShareService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(ShareService, _DAO);

  var _super = _createSuper(ShareService);

  function ShareService() {
    (0, _classCallCheck2["default"])(this, ShareService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ShareService, [{
    key: "_createUrl",

    /**
     * Helper method to create the share api url
     * @param {String} resourceUrl 
     */
    value: function _createUrl(resourceUrl) {
      var urn = (0, _utils.getUrn)(resourceUrl);

      if (!urn && this.apiVersion.toUpperCase() === 'V4') {
        throw new Error('Missing Resource URN');
      }

      if (urn) {
        return this.apiVersion.toUpperCase() === 'V4' ? "".concat(this.endpoint, "/share/").concat(encodeURIComponent(urn)) : "".concat(this.endpoint, "/share/urn/").concat(encodeURIComponent(urn));
      }

      return "".concat(this.endpoint, "/share/").concat((0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)));
    }
    /**
    * get - get sharing information for a resource
     * @param {Object} request - request object 
     *   @property {String} resourceUrl - CC Storage path (path based or ID-based)
     *   @property {Object} params - request object to send as body or added to request url depending on request type
    * @returns {Promise}
    */

  }, {
    key: "get",
    value: function get(request) {
      var _ref = request || {},
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {
        fields: 'descendants',
        extraFeatures: 'orgEverybody'
      } : _ref$params,
          resourceUrl = _ref.resourceUrl;

      if (!resourceUrl) {
        throw new Error('Missing Resource resource Url');
      }

      return this.getRequest({
        url: this._createUrl(resourceUrl),
        params: params
      });
    }
    /**
     * @method patch
     * Modify or remove sharing for a resource
     * 
     * @param {Object} req - request object 
     *   @property {String} resourceUrl - CC Storage path (path based or ID-based)
     *   @property {Object} request - object with all the entities that you want to change.
     * @returns {Promise}
     */

  }, {
    key: "patch",
    value: function patch(params) {
      var _ref2 = params || {
        request: {}
      },
          _ref2$request = _ref2.request,
          request = _ref2$request === void 0 ? {} : _ref2$request,
          resourceUrl = _ref2.resourceUrl;

      if (!resourceUrl || (0, _lodash["default"])(request) < 1) {
        throw new Error('Missing Resource Path or Request paramaters');
      }

      return this.patchRequest({
        url: this._createUrl(resourceUrl),
        params: request
      });
    }
    /**
     * @method post
     * Add collaborators or invitations for a resource
     * 
     * @param {Object} req - request object 
     *   @property {String} resourceUrl - CC Storage path (path based or ID-based)
     *   @property {Object} request - object with all the paramaters to send request to individual entities
     * @returns {Promise} 
     */

  }, {
    key: "post",
    value: function post(params) {
      var _ref3 = params || {
        request: {}
      },
          _ref3$request = _ref3.request,
          request = _ref3$request === void 0 ? {} : _ref3$request,
          resourceUrl = _ref3.resourceUrl;

      if (!resourceUrl || (0, _lodash["default"])(request) < 1) {
        throw new Error('Missing Resource Path or Request paramaters');
      }

      return this.postRequest({
        url: this._createUrl(resourceUrl),
        params: request
      });
    }
  }]);
  return ShareService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(ShareService, InstanceConfig);

exports["default"] = _default;